export const formatDate = (formattingMap, value) => (value ? formattingMap.date(value) : '');

export const formatNumber = (value) => {
  if (value === null || value === undefined) return '0';
  if (Number.isInteger(value)) return String(value);
  return Number(value).toFixed(2);
};

export const formatMoney = (formattingMap, value) =>
  formattingMap?.currency(Number(value) || 0, { includeZero: true }) ?? `${Number(value || 0).toFixed(2)}`;
